// @flow
import "./contextPath";

import createUUID from "../utils/helpers/createUUID";
import { getFullRequestHref } from "./requestInformation";

import {
  createReduxStore,
  setI18n,
  setServerPreferences,
  setConfigurationTheme,
} from "./serverUtil";

import { handleBeforeRenderHooks } from "../redux/store/beforeRenderHooks";

import renderSSRComplete from "./renderSSRComplete";

import type { TemplateProps } from "./htmlpage";
import type { BeforeRenderHook } from "../redux/store/beforeRenderHooks";
import type { PreferenceValue } from "./serverUtil";
import type { LocaleConfiguration } from "../i18n/types";
type serverProps = {
  request: HttpServletRequestJava,
  locales?: Array<LocaleConfiguration>,
  customReducers?: Object,
  theme?: Object,
  serverPreferences?: Array<string | PreferenceValue>,
  render: Function,
  ErrorPage?: any,
  template?: (TemplateProps) => string,
  beforeRenderHooks?: Array<BeforeRenderHook>,
};

/**
 */
const serverSSR = ({
  request,
  locales,
  customReducers,
  serverPreferences = [],
  theme = null,
  render,
  ErrorPage,
  template,
  beforeRenderHooks,
}: serverProps): Promise<string> => {
  const UUID = createUUID();
  __webpack_nonce__ = UUID; // NOSONAR

  const requestHref = getFullRequestHref(request);
  const store = createReduxStore(requestHref, customReducers);

  setServerPreferences(store, serverPreferences);
  setConfigurationTheme(store);
  setI18n(store, locales, request);

  handleBeforeRenderHooks(beforeRenderHooks, { request, store });

  return renderSSRComplete({
    store,
    theme,
    UUID,
    requestHref,
    render,
    ErrorPage,
    template,
  });
};

export default serverSSR;
